import React from 'react';
import { CATEGORIES, COLORS } from '@/data';
import type { Clip } from '@/types';

interface ClipDragPreviewProps {
  clip: Clip;
}

export const ClipDragPreview: React.FC<ClipDragPreviewProps> = ({ clip }) => {
  const category = CATEGORIES.find(c => c.id === clip.categoryId);

  return (
    <div
      className="bg-zinc-800 rounded-lg p-3 shadow-2xl border-2 flex items-center gap-3 w-64"
      style={{ borderColor: COLORS.lime }}
    >
      {/* Category emoji */}
      <span className="text-2xl flex-shrink-0">{category?.emoji || '📎'}</span>

      {/* Clip info */}
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-semibold truncate">{clip.title}</p>
        <p className="text-lime-400 text-xs">{category?.name || 'Unknown'}</p>
      </div>
    </div>
  );
};
